import { Container, Graphics, Sprite } from "@pixi/react";
import { useEffect, useRef, useState } from "react";
import { gameModuleService } from "../../services/gameModuleService";
import { Texture } from "pixi.js";
import WinLine from "../winLine";
import { observer } from "mobx-react-lite";
import { gameConfigurationStore } from "../../store/gameConfigurationStore";


export const ReelContainer = observer(() => {
    const reelContainerRef = useRef();
    const winContainerRef = useRef();
    const touchSpinScreenRef = useRef();
    const { symbolsSizes, reelsContainerParams } = gameConfigurationStore
    const [mask, setMask] = useState(null);
    const reelContainerConfig = {
        x: reelsContainerParams.xInFigma + symbolsSizes.width / 2,
        y: reelsContainerParams.yInFigma + symbolsSizes.height / 2,
        width: reelsContainerParams.width,
        height: reelsContainerParams.height,
    }
    const touchSpinScreenConfig = {
        x: reelsContainerParams.xInFigma,
        y: reelsContainerParams.yInFigma,
        width: reelsContainerParams.width,
        height: reelsContainerParams.height,
    }
    useEffect(() => {
        if (reelContainerRef.current) {
            reelContainerRef.current.mask = mask;
        }
    }, [mask, reelContainerRef]);
    useEffect(() => {
        gameModuleService.createReels(
            reelContainerRef.current,
            winContainerRef.current,
            touchSpinScreenRef.current,
        );
    }, []);
    return <>
        <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
            <Graphics
                draw={(g) => {
                    g.beginFill(0xff700b);
                    g.drawRect(
                        -symbolsSizes.width / 2 + reelsContainerParams.offsetForContainerBoardWidth,
                        -symbolsSizes.height / 2 + reelsContainerParams.offsetForContainerBoardHeight,
                        reelsContainerParams.width - (reelsContainerParams.offsetForContainerBoardWidth),
                        reelsContainerParams.height - (reelsContainerParams.offsetForContainerBoardHeight),
                    );
                }}
                ref={(graphicsRef) => setMask(graphicsRef)}
            />
        </Container>
        <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
        <WinLine />
        <Container ref={touchSpinScreenRef} {...touchSpinScreenConfig}>
            <Sprite
                texture={Texture.EMPTY}
                width={reelContainerConfig.width}
                height={reelContainerConfig.height}
            />
        </Container>

    </>
})
